export const API_URL = process.env.API || "https://api-discord-kcaf.onrender.com";
